<template>
	<div class="flex flex-col w-full justify-between py-3 px-4 border-ihh-gray/40">
		<div>
			<div class="flex w-full items-center">
				<div class="justify-center text-center mr-6">
					<div class="flex justify-center items-center space-x-8 shrink-0 min-w-[70px] min-h-[70px]">
						<img
							class="max-w-[70px] max-h-[70px] object-contain"
							src="https://cdn11.bigcommerce.com/s-nuj3c/stencil/29299650-2b9e-013d-ca92-06d759ad9f37/e/15c6ecf0-25f0-013d-e4f6-1e7f4d7752a0/img/GiftCertificate.png"
						/>
					</div>
				</div>

				<div class="flex flex-col w-full gap-y-2">
					<div class="w-full flex justify-between text-ihh-midnight-gray text-sm">
						<div class="flex flex-wrap line-clamp-2 max-w-[164px]">{{ certificate.quantity }} x Gift Certificate</div>
						<div>${{ (certificate.amount * certificate.quantity).toFixed(2) }}</div>
					</div>
					<div class="text-ihh-gray-700 px-2 text-xs">
						<div>
							<span>Recipient: </span>
							<span class="text-ihh-gray-700 font-normal">{{ certificate?.recipient?.name }}</span>
						</div>
						<div>
							<span>Email: </span>
							<span class="text-ihh-gray-700 font-normal">{{ certificate?.recipient?.email }}</span>
						</div>
					</div>
					<div class="flex w-full justify-between sm:pt-4 lg:pt-0"></div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'CheckoutCartCertificate',
	props: {
		certificate: {
			type: Object,
			required: true,
			validator: (cert) => 'amount' in cert && 'quantity' in cert && 'recipient' in cert,
		},
		index: {
			type: Number,
			required: true,
		},
	},
}
</script>
